import { forwardRef, type ReactNode } from 'react';

import type {
  AriaLabelingProps,
  DataTestId,
  DOMProps,
  MaskingProps,
  StylingProps,
} from '@dynatrace/strato-components/core';

import { Content as NotificationSettingsContent } from '../../../notifications/notification-settings/components/Content.js';

//#region Typings
/** @public */
export interface NotifyButtonContentProps
  extends DOMProps,
    AriaLabelingProps,
    StylingProps,
    MaskingProps,
    DataTestId {
  children?:
    | (({
        disabled,
        headingText,
        infoText,
        hasReadPermission,
        hasWritePermission,
      }: {
        disabled: boolean;
        headingText: string;
        infoText: string;
        hasReadPermission: boolean;
        hasWritePermission: boolean;
      }) => ReactNode)
    | ReactNode;
}
//#endregion Typings

/**
 * The content of the NotifyButton overlay.
 * @public
 */
export const Content = forwardRef<HTMLDivElement, NotifyButtonContentProps>(
  (props, ref) => {
    const { children, ...remainingProps } = props;

    return (
      <NotificationSettingsContent ref={ref} {...remainingProps}>
        {children}
      </NotificationSettingsContent>
    );
  },
);

(Content as typeof Content & { displayName: string }).displayName =
  'NotifyButton.Content';
